<template>
  <div>
    <Card>
      <div class="tab_g">
        <div class="tabs" ref="element">
          <div
            class="tab"
            v-for="(i,index) in tabs"
            @click="tabSwitch(index,i)"
            :key="index"
            :class="index == tabIndex ? 'active':''"
          >
            {{i.name}}
            <i></i>
          </div>
        </div>
        <div class="more" @click="more()" :class="moreText == '更多' ? '' : 'shou'" v-show="moreTab">
          <span>
            {{moreText}}
            <i class="el-icon-d-arrow-left"></i>
          </span>
        </div>
      </div>

      <div class="tables">
        <div class="item" style=" align-items: center;">
          <div class="tag">标签</div>
          <div class="tag_r label" style="display:flex;padding: 10px;">
            <div style="flex:1;transition: all 0.5s;" ref="element_tag">
              <CheckboxGroup v-model="tag" v-if="tags.length>0" @on-change="SelectTag">
                <Checkbox
                  v-for="(i,index) in tags"
                  :label="i.id"
                  :key="index"
                  class="labelItem"
                  style="margin:0 10px 0 0"
                >{{i.name}}</Checkbox>
              </CheckboxGroup>
              <span v-else>暂无标签</span>
            </div>
            <div
              class="more"
              @click="moreOpen()"
              :class="moreTagText == '更多' ? '' : 'shou'"
              v-show="moreTag"
            >
              <span>
                {{moreTagText}}
                <i class="el-icon-d-arrow-left"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="item" style=" align-items: center;">
          <div class="tag">评估</div>
          <div class="tag_r label" style="display:flex;padding: 10px;">
            <div style="flex:1;transition: all 0.5s;" ref="element_group">
              <CheckboxGroup
                v-model="invisible_group_ids"
                v-if="groupHides.length>0"
                @on-change="SelectGroup"
              >
                <Checkbox
                  v-for="(i,index) in groupHides"
                  :label="i.id"
                  :key="index"
                  class="labelItem"
                  style="margin:0 10px 0 0"
                >{{i.name}}</Checkbox>
              </CheckboxGroup>
              <span v-else>暂无评估</span>
            </div>
            <div
              class="more"
              @click="moreOpenHideGroup()"
              :class="moreGroupText == '更多' ? '' : 'shou'"
              v-show="moreGroup"
            >
              <span>
                {{moreGroupText}}
                <i class="el-icon-d-arrow-left"></i>
              </span>
            </div>
          </div>
        </div>
        <div
          class="item"
          style=" align-items: center;"
          v-if="tabs[this.tabIndex] && tabs[this.tabIndex].id"
        >
          <div class="tag" style="padding: 20px 10px;">入组时间</div>
          <div class="tag_r">
            <DatePicker
              :value="date"
              type="daterange"
              format="yyyy-MM-dd"
              :options="options"
              :transfer="true"
              placeholder="起始时间至截止时间"
              style="width:200px;margin-left:10px"
              @on-change="handleChange"
              @on-ok="handleOk"
              @on-clear="cleaDate"
              confirm
              clearable
            ></DatePicker>
          </div>
        </div>
        <div class="item">
          <div class="tag" style="padding: 20px 10px;">筛查记录</div>
          <div class="tag_r" style="padding: 10px 0;">
            <div class="list" @click="active()">
              <Input
                v-model="questionnaire_name"
                readonly
                style="width:200px;margin-left:10px"
                placeholder="请选择问卷"
                clearable
                @on-focus="quesModal"
                @on-clear="clearQues"
              ></Input>
            </div>
            <div class="list" @click="active()">
              <DatePicker
                clearable
                :value="date1"
                type="daterange"
                format="yyyy-MM-dd"
                :options="options"
                :transfer="true"
                placeholder="起始时间至截止时间"
                style="width:200px;margin-left:20px"
                @on-change="handleChange1"
                @on-clear="cleaDate1"
                confirm
              ></DatePicker>
            </div>
            <div class="list" @click="active()">
              <Select
                v-model="sex"
                placeholder="请选择性别"
                clearable
                style="width:200px;margin-left:20px"
              >
                <Option
                  v-for="item in sexList"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
            </div>
            <div class="list" style="margin-left:20px" @click="active()">
              <Input v-model="age1" placeholder="岁" clearable style="width: 100px" />&nbsp;--
              <Input v-model="age2" placeholder="岁" clearable style="width: 100px" />
            </div>
            <br />
            <el-collapse-transition>
              <div style="margin: 10px;" v-show="isClick">
                <Button type="primary" @click="handleOk()" style="margin-right: 10px;">确定</Button>
                <Button @click="cancel()">取消</Button>
              </div>
            </el-collapse-transition>
          </div>
        </div>
        <div class="item" style=" align-items: center;">
          <div class="tag" style="padding: 10px;">是否确诊</div>
          <div class="tag_r">
            <RadioGroup v-model="isConfirmed" @on-change="SelectConfirm">
              <Radio label style="margin:0 10px">全部</Radio>
              <Radio label="1" style="margin:0 10px">是</Radio>
              <Radio label="0" style="margin:0 10px">否</Radio>
            </RadioGroup>
          </div>
        </div>
      </div>

      <div class="total">
        <div class="left" v-if="haveData && list.length !== 0">
          <CheckboxGroup
            style="float:left;margin-right: 10px"
            v-model="chooseType"
            @on-change="choose"
          >
            <Checkbox label="current">全选当前页</Checkbox>
            <Checkbox label="all">全选所有页</Checkbox>
          </CheckboxGroup>

          <Button type="text" v-if="!isSelected">
            <span v-if="chooseType[0] == 'all'">已选({{total}}/{{total}})</span>
            <span v-else>已选({{personIds.length}}/{{total}})</span>
          </Button>
        </div>
        <div class="btns">
          <!-- <Button shape="circle" :disabled="isSelected" @click="message()">
            <i class="iconfont icon-xiaoxi1"></i>
            发送消息
          </Button>-->
          <Button shape="circle" @click="slow()">
            <i class="iconfont icon-zu247"></i>
            新增慢病档案
          </Button>
          <Button shape="circle" @click="follow()">
            <i class="iconfont icon-suifang"></i>
            新增随访
          </Button>
          <Button shape="circle" :disabled="isSelected" @click="transfer('transfer')">
            <i class="iconfont icon-zhuanyi"></i>
            转移标签
          </Button>
          <Button shape="circle" :disabled="isSelected" @click="transfer('remove')">
            <i class="iconfont icon-yichu"></i>
            移出标签
          </Button>
        </div>
      </div>

      <div class="cardType" v-if="haveData && list.length !== 0">
        <!-- 切换卡片/列表 -->
        <img v-if="cardType" @click="switchCards()" src="../../images/cardSelect.png" alt />
        <img v-else @click="switchCards()" src="../../images/cardUnselect.png" alt />
      </div>

      <div style="position:relative;min-height:400px;">
        <div v-if="haveData && list.length !== 0">
          <patientList
            :cardType="cardType"
            :list="list"
            :chooseType="chooseType"
            @childData="childData"
            @tagData="tagData"
            @followData="followData"
          ></patientList>
        </div>
        <div v-if="haveData && list.length === 0">
          <caringNoData></caringNoData>
        </div>
        <Spin size="large" fix v-if="!haveData"></Spin>
      </div>
      <div style="margin-top:16px;text-align:right;">
        <Page
          :total="total"
          :current="current"
          :page-size="size"
          :page-size-opts="sizes"
          :show-total="true"
          :show-elevator="true"
          :show-sizer="true"
          @on-change="onCurrentChange"
          @on-page-size-change="onSizeChange"
        />
      </div>
    </Card>

    <Modal v-model="isModalShow" :mask-closable="false" width="500" @on-cancel="cancelModal">
      <div slot="header" style="text-align: center">
        <span>{{tagType == 'transfer' ? '转移标签':'移出标签'}}</span>
      </div>
      <Form ref="formValidate" :model="cur" :rules="rules" :label-width="70" label-position="right">
        <FormItem label="标签" v-if="tagType == 'transfer'" required prop="tag">
          <Select v-model="cur.tag" multiple>
            <Option v-for="i in tags" :value="i.id" :disabled="i.disabled" :key="i.id">{{i.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="标签" v-else required prop="tag">
          <Select v-model="cur.tag" multiple>
            <Option v-for="i in tagsR" :value="i.id" :disabled="i.disabled" :key="i.id">{{i.name}}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelModal">取消</el-button>
        <el-button type="primary" round :loading="modalLoading" @click="save">保存</el-button>
      </div>
    </Modal>
    <!-- 问卷弹框 -->
    <questionModal
      :isModal="isModal"
      :category_id="category_id"
      @save="saveModal"
      @cancel="cancelModals"
    ></questionModal>
  </div>
</template>
<script>
// 自定义组件
import { getGroup } from '../../api/group'
import {
  getTag,
  TransferTag,
  removeTagPage,
  TransferTagTotal,
  removeTagTotal,
} from '../../api/tag'
import { getPatientList } from '../../api/patientList'
import patientList from '../common/patientList'
import caringNoData from '../common/caringNoData'
import route from '../../route/config'
import questionModal from '../common/questionModal'
export default {
  data: function () {
    return {
      tabs: [],
      tabIndex: 0,
      haveData: true,
      list: [],
      total: 0,
      current: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      tags: [],
      date: '',
      date1: '',
      quesList: [],
      sex: '',
      sexList: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '男',
        },
        {
          value: '0',
          label: '女',
        },
      ],
      isConfirmed: '',
      age1: '',
      age2: '',
      options: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        },
        shortcuts: [
          {
            text: '近一周',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              return [start, end]
            },
          },
          {
            text: '近一个月',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            },
          },
          {
            text: '近三个月',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end]
            },
          },
        ],
      },
      tag: [],
      invisible_group_ids: [],
      moreTab: false,
      moreTag: false,
      moreGroup: false,
      height: 32,
      moreText: '更多',
      moreTagText: '更多',
      moreGroupText: '更多',
      isClick: false,
      type: '0',
      questionnaireId: '',
      isModalShow: false,
      cur: {
        tag: '',
      },
      rules: {
        tag: [
          {
            required: true,
            message: '请选择标签',
            // trigger: 'change',
          },
        ],
      },
      modalLoading: false,
      isSelected: true,
      chooseType: [],
      disabled: false,
      personIds: [],
      personList: [],
      tagType: '',
      isModal: false,
      quesInfo: [],
      questionnaire_name: '',
      tagsR: '',
      category_id: '2',
      groupHides: [],
      cardType: true,
    }
  },
  computed: {},
  mounted() {
    this.getGroupHide()
    this.getGroupList()
    this.getTagList()
    // this.calcHeight()
  },
  methods: {
    switchCards() {
      this.cardType = !this.cardType
    },
    getGroupList: function () {
      let type = this.type
      let page = this.current
      let size = this.size
      let need_page = 0
      let invisible = 0
      getGroup({ type, page, size, need_page, invisible }).then((res) => {
        // this.loading = false
        if (res.code === 0) {
          let tabs = res.data
          tabs.unshift({
            id: '',
            name: '全部',
          })
          this.tabs = tabs
          this.$forceUpdate()
          this.getList()
          this.$nextTick(function () {
            this.calcHeight()
          })
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getGroupHide: function () {
      let type = this.type
      let page = this.current
      let size = this.size
      let need_page = 0
      let invisible = 1
      getGroup({ type, page, size, need_page, invisible }).then((res) => {
        if (res.code === 0) {
          this.groupHides = res.data
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getTagList: function () {
      let type = this.type
      let page = this.current
      let size = this.size
      let need_page = 0
      getTag({ type, page, size, need_page }).then((res) => {
        // this.loading = false
        if (res.code === 0) {
          let tags = res.data
          this.tags = tags
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getList: function () {
      this.haveData = false
      let obj = {
        group_id: this.tabs[this.tabIndex].id || '', //全部分组时传空
        tag_ids: this.tag, //无标签时传空
        enter_begin_time: this.date[0] ? this.date[0] + ' 00:00:00' : '',
        enter_end_time: this.date[1] ? this.date[1] + ' 23:59:59' : '',
        questionnaire_id:
          this.quesInfo.length > 0 ? this.quesInfo[0].questionnaire_id : '',
        filtrate_begin_time: this.date1[0] ? this.date1[0] + ' 00:00:00' : '',
        filtrate_end_time: this.date1[1] ? this.date1[1] + ' 23:59:59' : '',
        gender: this.sex || '', //0：女 1：男 不传：全部
        min_age: this.age1,
        max_age: this.age2,
        is_confirmed: this.isConfirmed, //0：未确诊 1：已确诊
        need_page: 1,
        page: this.current,
        size: this.size,
        invisible_group_ids: this.invisible_group_ids,
      }
      getPatientList(obj).then((res) => {
        this.haveData = true
        this.total = Number(res['x-total-count'])
        if (res.code === 0) {
          this.list = res.data
          if (this.list.length == 0) {
            this.isSelected = true
          } else {
            if (this.chooseType.length == 0) {
              this.list.forEach((v) => {
                v.selected = false
              })
            }
            if (this.chooseType[0] == 'all') {
              this.list.forEach((v) => {
                v.selected = true
              })
              this.isSelected = false
            } else {
              this.chooseType = []
              this.isSelected = true
            }
          }
          this.personList = []
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    SelectTag: function (data) {
      let tags = this.tags
      tags.forEach((v) => {
        if (data.length == 0) {
          v.disabled = false
        } else {
          data.forEach((j) => {
            if (v.id == j) {
              v.disabled = true
            } else {
              v.disabled = false
            }
          })
        }
      })
      this.tags = tags
      this.chooseType = []
      this.getList()
    },
    SelectGroup: function (data) {
      this.getList()
    },
    message: function () {},
    followData: function (i) {
      this.personList = []
      this.personList.push(i)
      this.follow()
    },
    follow: function () {
      // 新增随访
      let patientInfo = {}
      let arr = []
      this.personList.forEach((val) => {
        arr.push({
          user_id: val.user_id,
          patient_id: val.patient_id,
          name: val.name,
          age: val.age,
          phone: val.phone,
          wx_open_id: val.wx_open_id,
          wx_union_id: val.wx_union_id,
          gender: val.gender,
          id_card: val.id_card,
          province: val.province,
          city: val.city,
          county: val.county,
          address: val.address,
        })
      })
      patientInfo.personLists = arr

      patientInfo.type = {
        follow_code: '1280309721538105355',
        follow_name: '筛查中心随访',
        person_status: 4,
        choose_type: this.chooseType,
      }
      // 全选

      patientInfo.filterRequest = {
        group_id: this.tabs[this.tabIndex].id || '0', //全部分组时传空
        tag_ids: this.tag, //无标签时传空
        invisible_group_ids: this.invisible_group_ids,
        enter_begin_time: this.date[0] ? this.date[0] + ' 00:00:00' : '',
        enter_end_time: this.date[1] ? this.date[1] + ' 23:59:59' : '',
        questionnaire_id:
          this.quesInfo.length > 0 ? this.quesInfo[0].questionnaire_id : '',

        questionnaire_name: this.questionnaire_name,

        filtrate_begin_time: this.date1[0] ? this.date1[0] + ' 00:00:00' : '',
        filtrate_end_time: this.date1[1] ? this.date1[1] + ' 23:59:59' : '',
        gender: this.sex == '' ? 2 : this.sex, //0：女 1：男 不传：全部

        min_age: this.age1,
        max_age: this.age2,
        is_confirmed: this.isConfirmed == '' ? '2' : this.isConfirmed, //0：未确诊 1：已确诊
        need_page: 1,
        page: this.current,
        size: this.size,
      }

      this.$store.commit('setAllSelectedKeys', {
        type: 'delete',
        name: 'createFollow',
        title: '筛查中心随访',
        key: `createFollow?4`,
      })

      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'createFollow',
        title: '筛查中心随访',
        key: `createFollow?4`,
        extra: {
          patientInfo: patientInfo,
        },
      })
      this.refesh()
    },
    refesh() {
      const list = this.$store.state.allSelectedKeys.map((l) => {
        if (l.key === 'createFollow?4') {
          l.refesh = true
        }
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.$store.state.allSelectedKeys.map((l) => {
          if (l.key === 'createFollow?4') {
            l.refesh = false
          }
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    tabSwitch: function (index, i) {
      this.tabIndex = index
      this.getList()
    },
    onCurrentChange: function (current) {
      this.current = current
      this.getList()
    },
    onSizeChange: function (size) {
      this.size = size
      this.getList()
    },
    handleChange: function (date) {
      console.log(date)
      this.date = date
    },
    handleChange1: function (date) {
      this.date1 = date
    },
    cleaDate: function () {
      this.date = ''
      this.getList()
    },
    cleaDate1: function () {
      this.date1 = ''
    },
    handleOk: function () {
      this.current = 1
      this.getList()
      this.isClick = false
    },

    SelectConfirm: function () {
      this.getList()
    },

    calcHeight: function () {
      let self = this
      const element = self.$refs.element
      const element_tag = self.$refs.element_tag
      const element_group = self.$refs.element_group

      let height = element.offsetHeight //100
      let height2 = element_tag.offsetHeight
      let height3 = element_group.offsetHeight
      self.openHeight = height
      self.openHeight2 = height2
      self.openHeight3 = height3
      self.height = height

      if (height > 38) {
        //两行
        element.style.height = 32 + 'px'
        element.style.overflow = 'hidden'
        self.moreTab = true
      } else {
        self.moreTab = false
      }

      if (height2 > 23) {
        //两行
        element_tag.style.height = 22 + 'px'
        element_tag.style.overflow = 'hidden'
        self.moreTag = true
      } else {
        self.moreTag = false
      }

      if (height3 > 23) {
        //两行
        element_group.style.height = 22 + 'px'
        element_group.style.overflow = 'hidden'
        self.moreGroup = true
      } else {
        self.moreGroup = false
      }
    },
    more: function () {
      const element = this.$refs.element
      if (this.moreText == '更多') {
        element.style.height = this.openHeight + 'px'
        this.moreText = '收起'
      } else {
        element.style.height = 32 + 'px'
        this.moreText = '更多'
      }
    },
    moreOpen: function () {
      const element = this.$refs.element_tag
      if (this.moreTagText == '更多') {
        element.style.height = this.openHeight2 + 'px'
        this.moreTagText = '收起'
      } else {
        element.style.height = 22 + 'px'
        this.moreTagText = '更多'
      }
    },
    moreOpenHideGroup: function () {
      const element = this.$refs.element_group
      if (this.moreGroupText == '更多') {
        element.style.height = this.openHeight3 + 'px'
        this.moreGroupText = '收起'
      } else {
        element.style.height = 22 + 'px'
        this.moreGroupText = '更多'
      }
    },
    choose: function (type) {
      if (this.chooseType.length > 1) {
        this.chooseType.shift()
      }
      // console.log(type, this.chooseType)
      if (this.chooseType.length) {
        this.personIds = []
        this.personList = []
        let list = JSON.parse(JSON.stringify(this.list))
        list.forEach((v) => {
          v.selected = true
          this.personIds.push(v.id)
          this.personList.push(v)
        })
        this.list = list
        this.isSelected = false
      } else {
        this.personIds = []
        this.personList = []
        let list = JSON.parse(JSON.stringify(this.list))
        list.forEach((v) => {
          v.selected = false
        })
        this.list = list
        this.isSelected = true
      }
    },
    childData: function (data) {
      let selectedLength = 0
      this.personIds = []
      this.personList = []
      data.forEach((v) => {
        if (v.selected) {
          selectedLength++
          this.personIds.push(v.id)
          this.personList.push(v)
        }
      })

      if (selectedLength === this.list.length) {
        if (this.chooseType.length === 0) {
          this.chooseType = ['current']
        }
      } else if (this.chooseType.includes('current')) {
        this.chooseType = []
      }

      if (selectedLength > 0) {
        this.isSelected = false
      } else {
        this.isSelected = true
      }
    },
    active: function () {
      this.isClick = true
    },
    cancel: function () {
      this.isModal = false
      this.isClick = false
    },
    cancelModal: function () {
      this.isModalShow = false
      this.$refs.formValidate.resetFields()
    },
    tagData: function (type, i) {
      this.personIds = []
      this.transfer(type)
      this.personIds.push(i.id)
    },
    transfer: function (type) {
      this.tagType = type
      this.isModalShow = true
      const tags = JSON.parse(JSON.stringify(this.tags))
      if (type == 'remove') {
        tags.forEach((v) => {
          if (v.disabled) {
            delete v.disabled
          }
        })
      }
      this.tagsR = tags
    },
    save: function () {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.modalLoading = true
          let obj1 = {
            type: this.type,
            person_ids: this.personIds,
            from_tag_ids: this.tag,
            to_tag_ids: this.cur.tag,
          }
          let obj2 = {
            type: this.type,
            person_ids: this.personIds,
            tag_ids: this.cur.tag,
          }
          let obj3 = {
            type: this.type,
            from_tag_ids: this.tag,
            to_tag_ids: this.cur.tag,
            filter_request: {
              group_id: this.tabs[this.tabIndex].id || '', //全部分组时传空
              tag_ids: this.tag, //无标签时传空
              invisible_group_ids: this.invisible_group_ids,
              enter_begin_time: this.date[0] ? this.date[0] + ' 00:00:00' : '',
              enter_end_time: this.date[1] ? this.date[1] + ' 23:59:59' : '',
              questionnaire_id:
                this.quesInfo.length > 0
                  ? this.quesInfo[0].questionnaire_id
                  : '',
              filtrate_begin_time: this.date1[0]
                ? this.date1[0] + ' 00:00:00'
                : '',
              filtrate_end_time: this.date1[1]
                ? this.date1[1] + ' 23:59:59'
                : '',
              gender: this.sex, //0：女 1：男 不传：全部
              min_age: this.age1,
              max_age: this.age2,
              is_confirmed: this.isConfirmed, //0：未确诊 1：已确诊
              need_page: 1,
              page: this.current,
              size: this.size,
            },
          }
          let obj4 = {
            type: this.type,
            tag_ids: this.cur.tag,
            filter_request: {
              group_id: this.tabs[this.tabIndex].id || '', //全部分组时传空
              tag_ids: this.tag, //无标签时传空
              invisible_group_ids: this.invisible_group_ids,
              enter_begin_time: this.date[0] ? this.date[0] + ' 00:00:00' : '',
              enter_end_time: this.date[1] ? this.date[1] + ' 23:59:59' : '',
              questionnaire_id:
                this.quesInfo.length > 0
                  ? this.quesInfo[0].questionnaire_id
                  : '',
              filtrate_begin_time: this.date1[0]
                ? this.date1[0] + ' 00:00:00'
                : '',
              filtrate_end_time: this.date1[1]
                ? this.date1[1] + ' 23:59:59'
                : '',
              gender: this.sex, //0：女 1：男 不传：全部
              min_age: this.age1,
              max_age: this.age2,
              is_confirmed: this.isConfirmed, //0：未确诊 1：已确诊
              need_page: 1,
              page: this.current,
              size: this.size,
            },
          }
          // 所有页
          if (this.chooseType[0] == 'all') {
            // 转移
            if (this.tagType == 'transfer') {
              TransferTagTotal(obj3).then((res) => {
                if (res.code === 0) {
                  this.$Message.success('转移成功')
                  this.modalLoading = false
                  this.cancelModal()
                  this.getList()
                  this.personIds = []
                  this.personList = []
                } else {
                  this.$Message.error(res.message)
                }
              })
            } else {
              removeTagTotal(obj4).then((res) => {
                if (res.code === 0) {
                  this.$Message.success('移出成功')
                  this.modalLoading = false
                  this.cancelModal()
                  this.getList()
                  this.personIds = []
                  this.personList = []
                } else {
                  this.$Message.error(res.message)
                }
              })
            }
          } else {
            // 转移
            if (this.tagType == 'transfer') {
              TransferTag(obj1).then((res) => {
                if (res.code === 0) {
                  this.$Message.success('转移成功')
                  this.modalLoading = false
                  this.cancelModal()
                  this.getList()
                  this.personIds = []
                  this.personList = []
                } else {
                  this.$Message.error(res.message)
                }
              })
            } else {
              removeTagPage(obj2).then((res) => {
                if (res.code === 0) {
                  this.$Message.success('移出成功')
                  this.modalLoading = false
                  this.cancelModal()
                  this.getList()
                  this.personIds = []
                  this.personList = []
                } else {
                  this.$Message.error(res.message)
                }
              })
            }
          }
        }
      })
    },
    quesModal: function () {
      console.log('222')
      this.isModal = true
      this.isClick = true
    },
    saveModal: function (data) {
      if (data && data.length) {
        this.quesInfo = data
        this.questionnaire_name = data[0].questionnaire_name
        this.isModal = false
      } else {
        this.$Message.warning('请选择筛查问卷')
      }
    },
    cancelModals() {
      this.isModal = false
    },
    clearQues() {
      this.quesInfo = []
    },
    slow() {
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'slowPatient',
        title: '新增慢病患者',
        key: `slowPatient`,
        extra: {},
      })
    },
  },
  components: {
    patientList,
    caringNoData,
    questionModal,
  },
}
</script>
<style lang="less">
.page-scheme {
  background-color: #fff;
}
.ivu-btn.analysis {
  border: none;
}
.ivu-btn.analysis.active {
  border: 1px solid #2d8cf0;
}
.tab_g {
  display: flex;
  border-bottom: 1px solid #e3e7f0;
  // line-height: 45px;
  cursor: pointer;
  .tabs {
    // display: flex;
    transition: all 0.5s;
    flex: 1;
    .tab {
      margin: 0;
      margin-right: 20px;
      width: auto;
      float: left;
      padding-bottom: 10px;
      position: relative;
      margin-bottom: 5px;
      &.active {
        color: #1e6ff4;
        // border-bottom: 2px solid #1e6ff4;
        // padding-bottom: 4px;
        i {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: #1e6ff4;
        }
      }
    }
    &::after {
      clear: both;
      content: '';
      display: block;
      width: 0;
      height: 0;
      visibility: hidden;
    }
  }
  .moreTab {
    max-height: 32px;
    overflow: hidden;
  }

  .more {
    width: 80px;
    text-align: right;
    i {
      transform: rotate(270deg);
    }
  }
  .shou {
    i {
      transform: rotate(90deg);
    }
  }
}
.tables {
  margin-top: 20px;
  .item {
    width: 100%;
    display: flex;
    // align-items: center;
    border: 1px solid #ccc;
    border-bottom: none;
    .tag {
      width: 100px;
      text-align: center;
      background: #eff4f7;
      padding: 20px 10px;
      border-right: 1px solid #ccc;
    }
    .tag_r {
      flex: 1;
      .list {
        display: inline-block;
      }
      span {
        // margin: 0 20px;
        &.active {
          // color: #2d8cf0;
        }
      }
    }
  }
  .item:nth-last-child(1) {
    border-bottom: 1px solid #ccc;
  }
  .label {
    .more {
      width: 80px;
      text-align: right;
      margin-right: 10px;
      i {
        transform: rotate(270deg);
      }
    }
    .shou {
      i {
        transform: rotate(90deg);
      }
    }
  }
}

.total {
  display: flex;
  margin: 20px 0;
  .left {
    line-height: 34px;
  }
  .btns {
    flex: 1;
    text-align: right;
    button {
      margin: 0 5px;
    }
  }
}

.tag_r .ivu-cascader .ivu-select-dropdown {
  width: 200px;
}

/deep/ .el-input__prefix,
/deep/ .el-input__icon {
  line-height: 30px !important; // 可以通过设置行高改变图标在竖直方向上位置
}
.cardType img {
  width: 80px;
  margin-bottom: 20px;
}
</style>
